<div
  [class.error-state]="errorState"
  class="input-field"
  [class.has-icon]="!!icon"
  [class.has-value]="!!control.value"
  (click)="picker.open()"
  [class.focused]="focused"
>
  <mat-icon *ngIf="icon" [svgIcon]="icon" class="input-icon"></mat-icon>

  <input [matDatepicker]="picker"
         #input
         (blur)="checkValue()"
         [max]="max"
         [min]="min"
         [formControl]="control">
  <mat-datepicker #picker (opened)="focused=true" (closed)="focused=false"></mat-datepicker>
  <div *ngIf="showLabel" class="label">
    <ng-content select="[label]"></ng-content>
  </div>
</div>

<mat-hint [align]="hintAlign" *ngIf="!errorState">
  <ng-content select="[hint]"></ng-content>
</mat-hint>

<mat-error [class.invisible]="!errorState">
  {{ error | translate}}
</mat-error>
